/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation, useRouter } from 'js/lib/useRouter';

import { Button, breakpoints } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/front-page';

const redirectUrl = '/onboarding?src=banner,frontpage';

type Props = {
  label?: string;
};

const styles = {
  button: css`
    ${breakpoints.down('xs')} {
      width: 100%;
    }
  `,
};

export const JoinForFreeButton = (props: Props) => {
  const { label = _t('Join for Free') } = props;
  const trackEvent = useTracker();
  const router = useRouter();
  const location = useLocation();

  const handleCTAClick = () => {
    trackEvent('click_button', {
      button: { name: 'signup' },
      pageSection: { sectionName: 'hero_banner' },
    });

    const query = { ...(location?.query || {}), authMode: 'signup' };

    router.replace(
      {
        pathname: location?.pathname || '/',
        query,
      },
      // @ts-expect-error
      { pathname: router?.asPath?.split('?')?.[0], query }
    );
  };

  return (
    <Button
      component={TrackedButton}
      requireFullyVisible={false}
      withVisibilityTracking={false}
      trackingName="banner_cta"
      data={{ copy: label, href: redirectUrl }}
      css={styles.button}
      onClick={handleCTAClick}
      data-elementtiming="frontpage.banner.cta"
      data-testid="enroll-button"
    >
      {label}
    </Button>
  );
};

export default JoinForFreeButton;
